import { createContext, useContext } from 'react';

import type { CheckoutAppProps } from '../CheckoutApp';

const layoutContext = createContext<
  CheckoutAppProps['containerVariant'] | null
>(null);

export const LayoutProvider = layoutContext.Provider;

export const useLayoutContext = () => {
  const layout = useContext(layoutContext);
  if (layout == null) {
    throw new Error('useLayoutContext must be used within the LayoutProvider');
  }

  return layout;
};
